import { SubBar } from '@elderbyte/ngx-starter'
import { ProgressBarColors } from './ProgressBarColors'

export class ProgressBarUtils {
  public static calculateBars(
    completed: number,
    progress: number,
    readyForProduction: number,
    onHold: number,
    total: number
  ): SubBar[] {
    const bars: SubBar[] = []

    if (completed > 0) {
      bars.push(new SubBar((100 / total) * completed, ProgressBarColors.completed))
    }
    if (progress > 0) {
      bars.push(new SubBar((100 / total) * progress, ProgressBarColors.progress))
    }
    if (readyForProduction > 0) {
      bars.push(
        new SubBar((100 / total) * readyForProduction, ProgressBarColors.readyForProduction)
      )
    }

    if (onHold > 0) {
      bars.push(new SubBar((100 / total) * onHold, ProgressBarColors.onHold))
    }

    return bars
  }
}
